<template>
  <div style="margin: 20px 15px 20px 15px; padding: 30px 25px 30px 25px; background-color: white">
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="timestamp"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            clearable
            editable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="对冲产品:">
        <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标类型:">
        <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-for="item in hedgeTargetTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标值:">
        <el-input v-model="hedgeTargetValue" placeholder="请输入对冲目标类值"></el-input>
      </el-form-item>
      <el-form-item label="交易对:">
        <el-input v-model="pair" placeholder="请输入交易对"></el-input>
      </el-form-item>
      <el-form-item label="轮询开关：">
        <el-switch
            v-model="pollingOp.polling"
            active-text="开"
            inactive-text="关">
        </el-switch>
      </el-form-item>
      <el-form-item label="自动快照：" v-if="pollingOp.polling === true">
        <el-select v-model="pollingOp.fresh" placeholder="请选择对冲目标类型">
          <el-option v-for="item in freshOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryStrategy">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" :plain="true" @click="clear">清除快照缓存</el-button>
      </el-form-item>
    </el-form>

    <div class="block" v-if="isShow">
      <h2 style="text-align:center;background-color: gainsboro; padding: 15px 15px 15px 15px">历史需对冲快照</h2>
      <p v-for="(dataItem, time) in this.bookData">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item :title=time :name=time>
            <el-table :data=dataItem style="width: 100%" show-summary border show-header size="small">
              <el-table-column fixed prop="" label="交易对" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.strategy.split(':')[2] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="对冲量" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.quantityNotHedged }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="notHedgeUsdtAmt" label="对冲额U" sortable></el-table-column>
              <el-table-column prop="floatBenefitNotHedged" label="浮动盈亏U" sortable></el-table-column>
              <el-table-column prop="fixedBenefitTotal" label="固定盈亏U" sortable></el-table-column>
              <el-table-column prop="totalBenefit" label="累计盈亏U" sortable></el-table-column>
              <el-table-column prop="" label="现价" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.currentPrice }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" plain @click="exportExcel(dataItem)" size="small" style="text-align:right">导出Excel</el-button>
          </el-collapse-item>
        </el-collapse>
      </p>
      <h2 style="text-align:center;background-color: gainsboro;padding: 15px 15px 15px 15px">需对冲汇总</h2>
      <el-card>
        <el-table :data="tableData" style="width: 100%" :summary-method="getSummaries" show-summary border show-header size="small">
          <el-table-column prop="pair" label="交易对"></el-table-column>
          <el-table-column prop="baseQuantityNotHedged" label="参照对冲量"></el-table-column>
          <el-table-column prop="baseNotHedgeUsdtAmt" label="参照对冲额U"></el-table-column>
          <el-table-column label="当前对冲量" sortable>
            <template slot-scope="scope">
              <span style="color:red; font-weight: bolder" v-if="scope.row.quantityNotHedged > 0">{{ scope.row.quantityNotHedged }}</span>
              <span style="color:green; font-weight: bolder" v-else>{{ scope.row.quantityNotHedged }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前对冲额U" sortable>
            <template slot-scope="scope">
              <span style="color:red; font-weight: bolder" v-if="scope.row.notHedgeUsdtAmt > 10000">{{ scope.row.notHedgeUsdtAmt }}</span>
              <span style="color:green; font-weight: bolder" v-else>{{ scope.row.notHedgeUsdtAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="对冲量波动" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.quantityNotHedgedDiff }}</span>
            </template>
          </el-table-column>
          <el-table-column label="对冲额波动U" sortable>
            <template slot-scope="scope">
              <span style="color:red; font-weight: bolder" v-if="scope.row.notHedgeUsdtAmtDiff > 10000">{{ scope.row.notHedgeUsdtAmtDiff }}</span>
              <span style="color:green; font-weight: bolder" v-else>{{ scope.row.notHedgeUsdtAmtDiff }}</span>
            </template>
          </el-table-column>
          <el-table-column label="波动占比(%)" sortable>
            <template slot-scope="scope">
              <span style="color:red; font-weight: bolder" v-if="scope.row.QuantityNotHedgedPercent > 30">{{ scope.row.QuantityNotHedgedPercent }}</span>
              <span style="color:green; font-weight: bolder" v-else>{{ scope.row.QuantityNotHedgedPercent }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="snapshotTime" label="参照时间" sortable></el-table-column>
          <el-table-column prop="currentTime" label="当前时间" sortable></el-table-column>
        </el-table>
      </el-card>
    </div>

  </div>
</template>

<script>
import './store'
import {mapActions, mapState} from "vuex";
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

const hedgeTargetTypeSPOTOptions = [
  {key:'', label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeSUPER_CONTRACTOptions = [
  {key:'', label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const freshOptions = [
  // {key:10000, label:'10秒钟'},
  // {key:20000, label:'20秒钟'},
  // {key:30000, label:'30秒钟'},
  // {key:600000, label:'10分钟轮询'},
  {key:1800000, label:'30分钟轮询'},
  {key:3600000, label:'1小时轮询'},
]
const columns=[
  {title:'策略',key:'strategy'},
  {title:'对冲量',key:'quantityNotHedged'},
  {title:'对冲额U',key:'notHedgeUsdtAmt'},
  {title:'浮动盈亏U',key:'floatBenefitNotHedged'},
  {title:'固定盈亏U',key:'fixedBenefitTotal'},
  {title:'累计盈亏',key:'totalBenefit'},
  {title:'现价',key:'currentPrice'},
]


export default {
  name: "NotHedgedMonitor",
  data(){
    return{
      isShow:false,
      pollingOp:{
        polling: false,
        fresh:1800000,
      },
      settlement: false,
      activeNames:[],
      tableData:[],
      userId:'',
      dateRange: [],
      pair:'',
      freshOptions: freshOptions,
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeTargetValue:'',
      hedgeTargetTypeEnum:'',

      productType:'',
      targetType:'',
      targetValue:'',

      coins:'',
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeSPOTOptions,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeSUPER_CONTRACTOptions,
      paramsBak:{},
      dataBuffer:{},
      bookData:{},
    }
  },
  methods:{
    exportExcel(data){
      let startTime = utils.getLocalTime(this.dateRange[0])
      let endTime = utils.getLocalTime(this.dateRange[1])
      let title = '对冲快照' + startTime + '-' + endTime
      for (let i in data){
        data[i].totalBenefit = data[i].fixedBenefitTotal + data[i].floatBenefitNotHedged
      }
      utils.export2Excel(columns, data, title)
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) { return prev + curr;}
            else { return prev; }
          }, 0);
          sums[index] += ' ';
        } else { sums[index] = '';}
      });
      return sums;
    },

    handleChange(val) {},

    clear(){
      this.bookData = {}
      this.tableData = []
    },

    queryStrategy(){
      if (this.dateRange.length !== 2 || String(this.dateRange[1]).split(",").length > 1){
        this.$message({showClose: true, message: '请选择日期', type: 'error'});return
      }
      if (new Date(this.dateRange[0]).getTime() > new Date().getTime()){
        this.$message({showClose: true, message: '时间选择错误，起止时间不合理', type: 'error'});return
      }
      if ( this.hedgeTargetType === "" ){
        this.$message({showClose: true, message: '请选择对冲目标类型', type: 'error'});return
      }
      if ( this.hedgeTargetValue === "" ){
        this.$message({showClose: true, message: '请输入对冲目标值', type: 'error'});return
      }
      if (this.pollingOp.polling === true) {
        this.$message({showClose: true, message: '自动快照对冲', type: 'success'});
      }
      if (this.paramsBak === {} || this.paramsBak !== this.params) {
        this.tableData = []
        this.paramsBak = this.params
      }

      utils.queryStrategyData(this.params).then((response)=>{
        this.isShow = true
        let respData = response.data

        // 快照数据
        let curr = "快照时间： " + utils.getLocalTime(new Date().getTime())
        respData = respData.filter((item)=>{
          this.$set(item, 'totalBenefit', item.floatBenefitNotHedged + item.fixedBenefitTotal)
          return item
        })

        // 需对冲归总
        this.bookData[curr] = respData
        for (let i in respData){
          let respItem = respData[i]
          let pair = respItem.strategy.split(":")[3]
          if (!this.dataBuffer.hasOwnProperty(pair)){
            respItem["pair"] = pair
            respItem["snapshotTime"] = utils.getLocalTime(new Date().getTime())
            respItem["currentTime"] = utils.getLocalTime(new Date().getTime())
            respItem["baseQuantityNotHedged"] = respItem.quantityNotHedged
            respItem["baseNotHedgeUsdtAmt"] = respItem.notHedgeUsdtAmt
            respItem["QuantityNotHedgedPercent"] = 0
            respItem["quantityNotHedgedDiff"] = 0
            respItem["notHedgeUsdtAmtDiff"] = 0
            this.dataBuffer[pair] = respItem
          } else {
            let factorItem = this.dataBuffer[pair]
            let oriQuantityNotHedged = factorItem.baseQuantityNotHedged
            let oriNotHedgeUsdtAmt = factorItem.baseNotHedgeUsdtAmt
            factorItem["currentTime"] = utils.getLocalTime(new Date().getTime())
            factorItem["quantityNotHedged"] = respItem.quantityNotHedged
            factorItem["notHedgeUsdtAmt"] = respItem.notHedgeUsdtAmt
            factorItem["quantityNotHedgedDiff"] =  respItem.quantityNotHedged - oriQuantityNotHedged
            factorItem["notHedgeUsdtAmtDiff"] =  respItem.notHedgeUsdtAmt - oriNotHedgeUsdtAmt
            factorItem["QuantityNotHedgedPercent"] = Math.abs((100 * factorItem["quantityNotHedgedDiff"] / oriQuantityNotHedged).toFixed(3))
          }
        }
        this.tableData = []
        for (let key in this.dataBuffer){
          this.tableData.push(this.dataBuffer[key])
        }
      })
    },
  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeProductTypeOptions', 'pickerOptions']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        userId: this.userId,
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pair:this.pair,
        settlement: this.settlement
      };
    },
  },
  watch:{
    hedgeProductType(val){
      if (val === "SPOT"){
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SPOT
      }else{
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SUPER_CONTRACT
      }
    },
    pollingOp:{
      handler(val){
        if (val.polling === true){
          window.clearInterval(this.timer)
          this.timer = window.setInterval(() => {
            setTimeout(this.queryStrategy, 0);
          }, parseInt(val.fresh));
        } else {
          window.clearInterval(this.timer)
        }
      },
      deep:true
    }
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
    this.pollingOp.fresh = this.freshOptions[0].key
  },
  beforeRouteLeave(to, form, next) {
    next()
    this.pollingOp.polling = false
    window.clearInterval(this.timer)
  },
  destroyed() {
    this.pollingOp.polling = false
    window.clearInterval(this.timer)
  },
}
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>